import { GPTGroupMetricListChatObject } from '@app/interfaces/gpt-metric-chats.type';
import { GPTGroupMetricListObjectType } from '@app/interfaces/gpt-metric.type';
import { MonitoringRecordDataType } from '@app/interfaces/qm-module/qm-manage/qm-monioring-tasks.type';
import { createContext, Dispatch, SetStateAction, useContext } from 'react';

export type AudioContext = {
  withMetric: boolean;
  appealResolveMode: boolean | undefined;
  recordId: string;
  appeal_id: string | undefined;
  recordMfId: string | undefined;
  projectId: string | undefined;
  toggleEmotions: boolean;
  changeToggleEmotions: Dispatch<SetStateAction<boolean>>;
  currentTemplate: 'chat' | 'voice';
  recordMonitoring?: {
    recordMonitoringData: MonitoringRecordDataType | undefined;
    recordMonitoringLoading: boolean;
  };
  gptGroupsList: GPTGroupMetricListChatObject | GPTGroupMetricListObjectType | undefined;
};
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const audioContextProvider = createContext<AudioContext>(null!);
export const useAudioContext = () => useContext(audioContextProvider);

export default audioContextProvider;
